export const AXIOS_CONFIG = function () {
	return {
		baseURL: `${ppwMasterPasswords.restUrl}wppp/v1/`,
		timeout: 10000, //milisecond
		headers: {
			'Cache-Control': 'no-cache, no-store, must-revalidate',
			'Pragma': 'no-cache',
			'Expires': '0',
			'X-WP-Nonce': ppwMasterPasswords.nonce
		}
	}
}



// WEBPACK FOOTER //
// ./api/config.js